import { get } from 'lodash';

import { SelectedEnrolment } from '../../../common/hub/NewWithSelectedEnrolment';
import { cn } from '../../../v2/common/helpers/cn';

export const StudentEnrolmentDetails = ({
  student,
  subject,
  selectedEnrolment,
  className,
}: {
  student: string;
  subject: string;
  selectedEnrolment: SelectedEnrolment;
  className?: string;
}) => {
  const nextSessionTutor = get(selectedEnrolment, 'nextSessionTutor');
  const nextSessionDetail = get(selectedEnrolment, 'nextSessionDetail');

  return (
    <div className={cn('flex flex-col gap-y-2 rounded-lg bg-brown-200 p-4', className)}>
      <p className="mb-0 text-lg font-semibold leading-tight">{`${student}'s ${subject} enrolment`}</p>
      {!nextSessionDetail.includes('Invalid date') && (
        <div className="flex flex-col gap-y-4 md:flex-row md:gap-x-2">
          {nextSessionTutor && <p className="mb-0 leading-tight">{nextSessionTutor}</p>}
          {nextSessionDetail && <p className="mb-0 font-semibold leading-tight">{nextSessionDetail}</p>}
        </div>
      )}
    </div>
  );
};
